import { TableConfig, UnknownQuestionHeaderSortMap, UnkownQuestionsTableHeaderTitles } from './types'
import { CSSProperties } from 'react'

const alightCenterStyles: CSSProperties = { width: '100%', justifyContent: 'center' }

export const unansweredQuestionsTableConfig: TableConfig<UnkownQuestionsTableHeaderTitles> = {
  question: { maxWidth: '25%', title: 'Question', paddingRight: 30 },
  type: { maxWidth: '12%', title: 'Type', styles: alightCenterStyles },
  answer: { maxWidth: '25%', title: 'Answer' },
  assignUser: { maxWidth: '12%', title: 'User', styles: alightCenterStyles },
  trainButton: { maxWidth: '10%', title: 'Train', styles: alightCenterStyles },
  createAt: { maxWidth: '10%', title: 'Created At', styles: alightCenterStyles },
  editButton: { maxWidth: '3%', title: '' },
  removeButton: { maxWidth: '3%', title: '' },
}

export const unansweredQuestionsTableTitles = Object.values(unansweredQuestionsTableConfig).map(
  ({ title, maxWidth, styles }) => ({ title, maxWidth, styles }),
)

export const unknownQuestionTypeValue = 'unknown'

export const unansweredQuestionTypeLabels: Record<string, string> = {
  'unknown': 'Unknown',
  'faq': 'FAQ',
}

export const unansweredQuestionsQueryParamNamesMap: Record<string, keyof UnknownQuestionHeaderSortMap> = {
  createdat: 'Created At',
  user: 'User',
  train: 'Train',
  answer: 'Answer',
}
